import script from "./PestsModalContent.vue?vue&type=script&setup=true&lang=js"
export * from "./PestsModalContent.vue?vue&type=script&setup=true&lang=js"

import "./PestsModalContent.vue?vue&type=style&index=0&id=3a79eb3d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a79eb3d"]])

export default __exports__